import { ReactNode, useRef, useEffect, MouseEvent } from 'react';
import { createPortal } from 'react-dom';

import { KEYS } from "~/const";
import Close from "~/svgs/Close";

import "./style.less";

interface IModal {
	children: ReactNode;
	className: string;
	onClose?: () => void;
	outsideAreaClose?: boolean;
	onClick?: (event: MouseEvent) => void;
}

export default function Modal({
	children = null,
	className = "",
	onClose = () => {},
	outsideAreaClose = false,
	onClick = () => {},
} : IModal) {
	const modalRef = useRef<HTMLDivElement>(null);
	const innerRef = useRef<HTMLDivElement>(null);
	const classess = [
		"modal-window",
		...className ? [className] : [],
	].join(" ");

	function handleEscape(event: KeyboardEvent) {
		if (event.key === KEYS.ESC) {
			onClose();
		}
	}

	function onModalClick(event: MouseEvent) {
		const target = event.target as HTMLDivElement;

		if (outsideAreaClose && !innerRef?.current?.contains(target)) {
			onClose();
		}

		onClick(event);
	}

	useEffect(() => {
		document.addEventListener('keydown', handleEscape);
		document.body.classList.add("modal-no-scroll");

		return () => {
			document.body.classList.remove("modal-no-scroll");
			document.removeEventListener('keydown', handleEscape);
		};
	}, []);

	return createPortal(
		<div className="modal" ref={modalRef} onClick={onModalClick}>
			<div className={classess} ref={innerRef}>
				<button type="button" onClick={() => onClose()} className="modal-window-btn-close">
					<Close />
				</button>
				{children}
			</div>
		</div>,
		document.querySelector('#portal') || document.body,
	);
}
